import { render, staticRenderFns } from "./BaseWarehouseWithToolTip.vue?vue&type=template&id=3a2621a2&scoped=true&"
import script from "./BaseWarehouseWithToolTip.vue?vue&type=script&lang=js&"
export * from "./BaseWarehouseWithToolTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2621a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
